import { m } from "#/paraglide/messages";
import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@beweegbaas/ui";
import { createFileRoute, Link, Outlet, stripSearchParams } from "@tanstack/react-router";
import { LessonsHeader } from "#/components/lessons-header";
import { Page } from "#/components/page";
import { PendingContent } from "#/components/pending-content";
import { LessonsOverviewTableLayout } from "#/modules/school.lessen/components/lessons-overview-table-layout";
import { getLessonsOverview } from "#/modules/school.lessen/lessons.functions";
import {
  LESSONS_SEARCH_DEFAULTS,
  lessonsSearchSchema,
} from "#/modules/school.lessen/schema.search";

// The lessen a docent gave, to look back on. What is coming up lives in the lesweek.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/lessons/")({
  validateSearch: lessonsSearchSchema,
  // Keeps the default filter out of the URL.
  search: { middlewares: [stripSearchParams(LESSONS_SEARCH_DEFAULTS)] },
  // Narrowed to exactly the keys the loader/server-fn uses — never the whole search object.
  loaderDeps: ({ search }) => ({ date: search.date, dateFilterValue: search.dateFilterValue }),
  loader: ({ deps }) => getLessonsOverview({ data: deps }),
  component: LessonsPage,
});

function LessonsPage() {
  const { locale, school } = Route.useParams();
  const params = { locale, school };
  const { lessons } = Route.useLoaderData();
  const { date, dateFilterValue } = Route.useSearch();
  const currentTabValue = `${dateFilterValue}:${date}`;

  return (
    <Page>
      <LessonsHeader currentTabValue={currentTabValue} />
      {lessons.length === 0 ? (
        <Empty>
          <EmptyHeader>
            <EmptyTitle>{m["lessen.geen_lessen_gevonden"]()}</EmptyTitle>
            <EmptyDescription>
              Lessen die je gegeven hebt, vind je hier terug. Wat er nog komt, staat in Mijn
              lesweek.
            </EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button
              variant="outline"
              size="xl"
              nativeButton={false}
              render={
                <Link
                  from={Route.fullPath}
                  to="/$locale/{-$schoolyear}/$school/lessons/week"
                  params={(prev: Record<string, string>) => prev}
                />
              }
            >
              {m["lessen.lesweek.tab"]()}
            </Button>
          </EmptyContent>
        </Empty>
      ) : (
        <Page.Body>
          <PendingContent>
            <LessonsOverviewTableLayout lessons={lessons} params={params} />
          </PendingContent>
        </Page.Body>
      )}
      <Outlet />
    </Page>
  );
}
